import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default () => ({
  path: "operational-days-and-time-zone",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "operational-days-and-time-zone-chunk" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const Component = importedModule0.default;
        return Component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
